import { connect } from 'react-redux'
import React from 'react'
import { LinearProgress } from 'react-md'

import { getAuthUser, getIsFetching } from 'redux/reducers'

import Layout from './Layout'
import Routes from './Routes'

const PrivateRoot = ({ authUser, isFetching }) => (
  <div>
    { isFetching && (
      <div className='app-progress'>
        <LinearProgress id='app-progress' />
      </div>
    ) }
    <Layout user={authUser}>
      <Routes role={authUser.role} />
    </Layout>
  </div>
)

const mapStateToProps = (state) => ({
  authUser: getAuthUser(state),
  isFetching: getIsFetching(state)
})

export default connect(mapStateToProps)(PrivateRoot)



// WEBPACK FOOTER //
// ./src/containers/PrivateRoot/index.js